import React from 'react';
import * as S from './TripActions.styles';

import IconSelector from '@ibibo/icon-selector';

const TripActions = ({authenticate, tripActions}) => {
    return(
      <S.TripInfoActionWrap>
        {tripActions.map((action) => <S.TripInfoActionInner key={action.title} onClick={() => {
            (action.icon == 'whatsapp' || action.icon == 'whatsapp-icon') ?
            authenticate(action.link) : window.open(action.link, '_blank');
          }}>
          <S.TripActionIconWrap  >
          <IconSelector iconKey={action.icon}/>
          </S.TripActionIconWrap>
          <S.TripInfoActionText>{action.title}</S.TripInfoActionText>
        </S.TripInfoActionInner>)
        }

      </S.TripInfoActionWrap>
    );
}

export default TripActions;